<template>
  <div>
    <v-overlay :opacity="1" :value="overlay" class="default_overlay">
      <Loading />
    </v-overlay>
    <v-app>
      <template v-if="!(isMobileApp && $route.meta?.infoPageConfig?.hideHeaderOnMobile)">
        <HomepageHeader :has-border="!isMobileApp" />
        <div class="header-end" />
      </template>
      <v-main
        :class="{
          gray: ['healthboxLanding', 'contactPage'].includes(currentPath)
        }"
      >
        <LetsTalkComponent v-if="currentPath === 'index'" />
        <slot />
      </v-main>
      <v-footer
        v-if="!isMobileApp"
        :color="footerWhite ? 'white' : 'undefined'"
        class="pa-0"
        data-cy="footer"
        tag="div"
      >
        <HomepageFooter />
      </v-footer>
      <ErrorModal />
      <UnsupportedBrowserModal id="unsupported-browser-modal" />
      <UnavailableClinics />
      <CookiesDialog />
      <AppLockOverlay v-if="$store.getters['appLock/isAppLockEnabled']" />
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import outsideClientZone from '~/mixins/layouts/outsideClientZone';
import HomepageFooter from '~/components/Organisms/Homepage/HomepageFooter.vue';
import authUserWatcher from '~/mixins/authUserWatcher';
import Loading from '~/components/Atoms/Loading.vue';
import HomepageHeader from '~/components/Organisms/Homepage/HomepageHeader.vue';
import ErrorModal from '~/components/Atoms/ErrorModal.vue';
import UnsupportedBrowserModal from '~/components/Atoms/UnsupportedBrowserModal.vue';
import AppLockOverlay from '@/feature/app-lock/components/AppLockOverlay.vue';
import UnavailableClinics from '~/components/Atoms/UnavailableClinics.vue';
import CookiesDialog from '~/components/Organisms/CookiesDialog.vue';
import NeedHelpFab from '~/components/Molecules/NeedHelpFab.vue';
import LetsTalkComponent from '~/components/Organisms/Homepage/LetsTalk.vue';

export default {
  name: 'HomepageLayout',
  components: {
    AppLockOverlay,
    NeedHelpFab,
    CookiesDialog,
    UnavailableClinics,
    UnsupportedBrowserModal,
    ErrorModal,
    HomepageHeader,
    Loading,
    LetsTalkComponent,
    HomepageFooter
  },
  mixins: [outsideClientZone, authUserWatcher],
  data() {
    return {
      overlay: true
    };
  },
  metaInfo: {
    script: [
      {
        src: import.meta.env.MODE === 'production' ? '/linkedin-tracking-code.js' : '',
        body: true
      }
    ]
  },
  computed: {
    ...mapGetters({
      footerWhite: 'general/footerWhite',
      token: 'apiToken/token'
    }),
    whiteBg() {
      return (
        (this.currentPath === 'login' && !this.$auth.user) ||
        (this.currentPath === 'registration' && !this.$route.query.step)
      );
    }
  },
  beforeMount() {
    this.setIsUlHc(this.$route.name.indexOf('aeskuLab') !== -1);
  },
  mounted() {
    const allowedMobileAppRoutes = ['verifyEmail', 'emergency'];

    if (this.isMobileApp && !allowedMobileAppRoutes.includes(this.currentPath)) {
      if (this.$auth.loggedIn) {
        this.$router.replace(this.$localePath('dashboard'));
      }
    }
    this.overlay = false;
    const observer = new IntersectionObserver(entries => {
      this.$store.dispatch('general/setIsScrolled', !entries[0].isIntersecting);
    });
    observer.observe(document.querySelector('.header-end'));
  },
  methods: {
    ...mapMutations({
      setIsUlHc: 'general/setIsUlHc'
    })
  }
};
</script>

<style lang="scss">
body .v-overlay--active.default_overlay {
  z-index: 14 !important;
  min-height: 100dvh !important;

  .v-overlay__scrim {
    opacity: 1 !important;
    background-color: $white !important;
    border-color: $white !important;
  }
}

html {
  scroll-behavior: smooth !important;
}
</style>
